// extracted by mini-css-extract-plugin
module.exports = {"tabletMiddle":"(max-width: 768px)","controls":"AVEVAOmaw7Kt","button":"_12hThmDsCyhv","back":"_3W_jy9s823Oj"};